export const classifications = {
    0: "Speech",
    1: "Child speech, kid speaking",
    2: "Conversation",
    3: "Narration, monologue",
    4: "Babbling",
    5: "Speech synthesizer",
    6: "Shout",
    7: "Bellow",
    8: "Whoop",
    9: "Yell",
    10: "Children shouting",
    11: "Screaming",
    12: "Whispering",
    13: "Laughter",
    14: "Baby laughter",
    15: "Giggle",
    16: "Snicker",
    17: "Belly laugh",
    18: "Chuckle, chortle",
    19: "Crying, sobbing",
    20: "Baby cry, infant cry",
    21: "Whimper",
    22: "Wail, moan",
    23: "Sigh",
    24: "Singing",
    25: "Choir",
    26: "Yodeling",
    27: "Chant",
    28: "Mantra",
    29: "Child singing",
    30: "Synthetic singing",
    31: "Rapping",
    32: "Humming",
    33: "Groan",
    34: "Grunt",
    35: "Whistling",
    36: "Breathing",
    37: "Wheeze",
    38: "Snoring",
    39: "Gasp",
    40: "Pant",
    41: "Snort",
    42: "Cough",
    43: "Throat clearing",
    44: "Sneeze",
    45: "Sniff",
    46: "Run",
    47: "Shuffle",
    48: "Walk, footsteps",
    49: "Chewing, mastication",
    50: "Biting",
    51: "Gargling",
    52: "Stomach rumble",
    53: "Burping, eructation",
    54: "Hiccup",
    55: "Fart",
    56: "Hands",
    57: "Finger snapping",
    58: "Clapping",
    59: "Heart sounds, heartbeat",
    60: "Heart murmur",
    61: "Cheering",
    62: "Applause",
    63: "Chatter",
    64: "Crowd",
    65: "Hubbub, speech noise, speech babble",
    66: "Children playing",
    67: "Animal",
    68: "Domestic animals, pets",
    69: "Dog",
    70: "Bark",
    71: "Yip",
    72: "Howl",
    73: "Bow-wow",
    74: "Growling",
    75: "Whimper (dog)",
    76: "Cat",
    77: "Purr",
    78: "Meow",
    79: "Hiss",
    80: "Caterwaul",
    81: "Livestock, farm animals, working animals",
    82: "Horse",
    83: "Clip-clop",
    84: "Neigh, whinny",
    85: "Cattle, bovinae",
    86: "Moo",
    87: "Cowbell",
    88: "Pig",
    89: "Oink",
    90: "Goat",
    91: "Bleat",
    92: "Sheep",
    93: "Fowl",
    94: "Chicken, rooster",
    95: "Cluck",
    96: "Crowing, cock-a-doodle-doo",
    97: "Turkey",
    98: "Gobble",
    99: "Duck",
    100: "Quack",
    101: "Goose",
    102: "Honk",
    103: "Wild animals",
    104: "Roaring cats (lions, tigers)",
    105: "Roar",
    106: "Bird",
    107: "Bird vocalization, bird call, bird song",
    108: "Chirp, tweet",
    109: "Squawk",
    110: "Pigeon, dove",
    111: "Coo",
    112: "Crow",
    113: "Caw",
    114: "Owl",
    115: "Hoot",
    116: "Bird flight, flapping wings",
    117: "Canidae, dogs, wolves",
    118: "Rodents, rats, mice",
    119: "Mouse",
    120: "Patter",
    121: "Insect",
    122: "Cricket",
    123: "Mosquito",
    124: "Fly, housefly",
    125: "Buzz",
    126: "Bee, wasp, etc.",
    127: "Frog",
    128: "Croak",
    129: "Snake",
    130: "Rattle",
    131: "Whale vocalization",
    132: "Music",
    133: "Musical instrument",
    134: "Plucked string instrument",
    135: "Guitar",
    136: "Electric guitar",
    137: "Bass guitar",
    138: "Acoustic guitar",
    139: "Steel guitar, slide guitar",
    140: "Tapping (guitar technique)",
    141: "Strum",
    142: "Banjo",
    143: "Sitar",
    144: "Mandolin",
    145: "Zither",
    146: "Ukulele",
    147: "Keyboard (musical)",
    148: "Piano",
    149: "Electric piano",
    150: "Organ",
    151: "Electronic organ",
    152: "Hammond organ",
    153: "Synthesizer",
    154: "Sampler",
    155: "Harpsichord",
    156: "Percussion",
    157: "Drum kit",
    158: "Drum machine",
    159: "Drum",
    160: "Snare drum",
    161: "Rimshot",
    162: "Drum roll",
    163: "Bass drum",
    164: "Timpani",
    165: "Tabla",
    166: "Cymbal",
    167: "Hi-hat",
    168: "Wood block",
    169: "Tambourine",
    170: "Rattle (instrument)",
    171: "Maraca",
    172: "Gong",
    173: "Tubular bells",
    174: "Mallet percussion",
    175: "Marimba, xylophone",
    176: "Glockenspiel",
    177: "Vibraphone",
    178: "Steelpan",
    179: "Orchestra",
    180: "Brass instrument",
    181: "French horn",
    182: "Trumpet",
    183: "Trombone",
    184: "Bowed string instrument",
    185: "String section",
    186: "Violin, fiddle",
    187: "Pizzicato",
    188: "Cello",
    189: "Double bass",
    190: "Wind instrument, woodwind instrument",
    191: "Flute",
    192: "Saxophone",
    193: "Clarinet",
    194: "Harp",
    195: "Bell",
    196: "Church bell",
    197: "Jingle bell",
    198: "Bicycle bell",
    199: "Tuning fork",
    200: "Chime",
    201: "Wind chime",
    202: "Change ringing (campanology)",
    203: "Harmonica",
    204: "Accordion",
    205: "Bagpipes",
    206: "Didgeridoo",
    207: "Shofar",
    208: "Theremin",
    209: "Singing bowl",
    210: "Scratching (performance technique)",
    211: "Pop music",
    212: "Hip hop music",
    213: "Beatboxing",
    214: "Rock music",
    215: "Heavy metal",
    216: "Punk rock",
    217: "Grunge",
    218: "Progressive rock",
    219: "Rock and roll",
    220: "Psychedelic rock",
    221: "Rhythm and blues",
    222: "Soul music",
    223: "Reggae",
    224: "Country",
    225: "Swing music",
    226: "Bluegrass",
    227: "Funk",
    228: "Folk music",
    229: "Middle Eastern music",
    230: "Jazz",
    231: "Disco",
    232: "Classical music",
    233: "Opera",
    234: "Electronic music",
    235: "House music",
    236: "Techno",
    237: "Dubstep",
    238: "Drum and bass",
    239: "Electronica",
    240: "Electronic dance music",
    241: "Ambient music",
    242: "Trance music",
    243: "Music of Latin America",
    244: "Salsa music",
    245: "Flamenco",
    246: "Blues",
    247: "Music for children",
    248: "New-age music",
    249: "Vocal music",
    250: "A capella",
    251: "Music of Africa",
    252: "Afrobeat",
    253: "Christian music",
    254: "Gospel music",
    255: "Music of Asia",
    256: "Carnatic music",
    257: "Music of Bollywood",
    258: "Ska",
    259: "Traditional music",
    260: "Independent music",
    261: "Song",
    262: "Background music",
    263: "Theme music",
    264: "Jingle (music)",
    265: "Soundtrack music",
    266: "Lullaby",
    267: "Video game music",
    268: "Christmas music",
    269: "Dance music",
    270: "Wedding music",
    271: "Happy music",
    272: "Sad music",
    273: "Tender music",
    274: "Exciting music",
    275: "Angry music",
    276: "Scary music",
    277: "Wind",
    278: "Rustling leaves",
    279: "Wind noise (microphone)",
    280: "Thunderstorm",
    281: "Thunder",
    282: "Water",
    283: "Rain",
    284: "Raindrop",
    285: "Rain on surface",
    286: "Stream",
    287: "Waterfall",
    288: "Ocean",
    289: "Waves, surf",
    290: "Steam",
    291: "Gurgling",
    292: "Fire",
    293: "Crackle",
    294: "Vehicle",
    295: "Boat, Water vehicle",
    296: "Sailboat, sailing ship",
    297: "Rowboat, canoe, kayak",
    298: "Motorboat, speedboat",
    299: "Ship",
    300: "Motor vehicle (road)",
    301: "Car",
    302: "Vehicle horn, car horn, honking",
    303: "Toot",
    304: "Car alarm",
    305: "Power windows, electric windows",
    306: "Skidding",
    307: "Tire squeal",
    308: "Car passing by",
    309: "Race car, auto racing",
    310: "Truck",
    311: "Air brake",
    312: "Air horn, truck horn",
    313: "Reversing beeps",
    314: "Ice cream truck, ice cream van",
    315: "Bus",
    316: "Emergency vehicle",
    317: "Police car (siren)",
    318: "Ambulance (siren)",
    319: "Fire engine, fire truck (siren)",
    320: "Motorcycle",
    321: "Traffic noise, roadway noise",
    322: "Rail transport",
    323: "Train",
    324: "Train whistle",
    325: "Train horn",
    326: "Railroad car, train wagon",
    327: "Train wheels squealing",
    328: "Subway, metro, underground",
    329: "Aircraft",
    330: "Aircraft engine",
    331: "Jet engine",
    332: "Propeller, airscrew",
    333: "Helicopter",
    334: "Fixed-wing aircraft, airplane",
    335: "Bicycle",
    336: "Skateboard",
    337: "Engine",
    338: "Light engine (high frequency)",
    339: "Dental drill, dentist's drill",
    340: "Lawn mower",
    341: "Chainsaw",
    342: "Medium engine (mid frequency)",
    343: "Heavy engine (low frequency)",
    344: "Engine knocking",
    345: "Engine starting",
    346: "Idling",
    347: "Accelerating, revving, vroom",
    348: "Door",
    349: "Doorbell",
    350: "Ding-dong",
    351: "Sliding door",
    352: "Slam",
    353: "Knock",
    354: "Tap",
    355: "Squeak",
    356: "Cupboard open or close",
    357: "Drawer open or close",
    358: "Dishes, pots, and pans",
    359: "Cutlery, silverware",
    360: "Chopping (food)",
    361: "Frying (food)",
    362: "Microwave oven",
    363: "Blender",
    364: "Water tap, faucet",
    365: "Sink (filling or washing)",
    366: "Bathtub (filling or washing)",
    367: "Hair dryer",
    368: "Toilet flush",
    369: "Toothbrush",
    370: "Electric toothbrush",
    371: "Vacuum cleaner",
    372: "Zipper (clothing)",
    373: "Keys jangling",
    374: "Coin (dropping)",
    375: "Scissors",
    376: "Electric shaver, electric razor",
    377: "Shuffling cards",
    378: "Typing",
    379: "Typewriter",
    380: "Computer keyboard",
    381: "Writing",
    382: "Alarm",
    383: "Telephone",
    384: "Telephone bell ringing",
    385: "Ringtone",
    386: "Telephone dialing, DTMF",
    387: "Dial tone",
    388: "Busy signal",
    389: "Alarm clock",
    390: "Siren",
    391: "Civil defense siren",
    392: "Buzzer",
    393: "Smoke detector, smoke alarm",
    394: "Fire alarm",
    395: "Foghorn",
    396: "Whistle",
    397: "Steam whistle",
    398: "Mechanisms",
    399: "Ratchet, pawl",
    400: "Clock",
    401: "Tick",
    402: "Tick-tock",
    403: "Gears",
    404: "Pulleys",
    405: "Sewing machine",
    406: "Mechanical fan",
    407: "Air conditioning",
    408: "Cash register",
    409: "Printer",
    410: "Camera",
    411: "Single-lens reflex camera",
    412: "Tools",
    413: "Hammer",
    414: "Jackhammer",
    415: "Sawing",
    416: "Filing (rasp)",
    417: "Sanding",
    418: "Power tool",
    419: "Drill",
    420: "Explosion",
    421: "Gunshot, gunfire",
    422: "Machine gun",
    423: "Fusillade",
    424: "Artillery fire",
    425: "Cap gun",
    426: "Fireworks",
    427: "Firecracker",
    428: "Burst, pop",
    429: "Eruption",
    430: "Boom",
    431: "Wood",
    432: "Chop",
    433: "Splinter",
    434: "Crack",
    435: "Glass",
    436: "Chink, clink",
    437: "Shatter",
    438: "Liquid",
    439: "Splash, splatter",
    440: "Slosh",
    441: "Squish",
    442: "Drip",
    443: "Pour",
    444: "Trickle, dribble",
    445: "Gush",
    446: "Fill (with liquid)",
    447: "Spray",
    448: "Pump (liquid)",
    449: "Stir",
    450: "Boiling",
    451: "Sonar",
    452: "Arrow",
    453: "Whoosh, swoosh, swish",
    454: "Thump, thud",
    455: "Thunk",
    456: "Electronic tuner",
    457: "Effects unit",
    458: "Chorus effect",
    459: "Basketball bounce",
    460: "Bang",
    461: "Slap, smack",
    462: "Whack, thwack",
    463: "Smash, crash",
    464: "Breaking",
    465: "Bouncing",
    466: "Whip",
    467: "Flap",
    468: "Scratch",
    469: "Scrape",
    470: "Rub",
    471: "Roll",
    472: "Crushing",
    473: "Crumpling, crinkling",
    474: "Tearing",
    475: "Beep, bleep",
    476: "Ping",
    477: "Ding",
    478: "Clang",
    479: "Squeal",
    480: "Creak",
    481: "Rustle",
    482: "Whir",
    483: "Clatter",
    484: "Sizzle",
    485: "Clicking",
    486: "Clickety-clack",
    487: "Rumble",
    488: "Plop",
    489: "Jingle, tinkle",
    490: "Hum",
    491: "Zing",
    492: "Boing",
    493: "Crunch",
    494: "Silence",
    495: "Sine wave",
    496: "Harmonic",
    497: "Chirp tone",
    498: "Sound effect",
    499: "Pulse",
    500: "Inside, small room",
    501: "Inside, large room or hall",
    502: "Inside, public space",
    503: "Outside, urban or manmade",
    504: "Outside, rural or natural",
    505: "Reverberation",
    506: "Echo",
    507: "Noise",
    508: "Environmental noise",
    509: "Static",
    510: "Mains hum",
    511: "Distortion",
    512: "Sidetone",
    513: "Cacophony",
    514: "White noise",
    515: "Pink noise",
    516: "Throbbing",
    517: "Vibration",
    518: "Television",
    519: "Radio",
    520: "Field recording"
}


export const instruments = {
    "String": [
        "Plucked string instrument",
        "Strum",
        "Banjo",
        "Sitar",
        "Mandolin",
        "Zither",
        "Ukulele",
        "Guitar",
        "Electric guitar",
        "Bass guitar",
        "Acoustic guitar",
        "Steel guitar, slide guitar",
        "Tapping (guitar technique)"],
    "Keyboard": [
        "Keyboard (musical)",
        "Piano",
        "Electric piano",
        "Organ",
        "Electronic organ",
        "Hammond organ",
        "Synthesizer",
        "Sampler",
        "Harpsichord"],
    "Percussion": [
        "Percussion",
        "Drum kit",
        "Drum machine",
        "Drum",
        "Snare drum",
        "Rimshot",
        "Drum roll",
        "Bass drum",
        "Timpani",
        "Tabla",
        "Cymbal",
        "Hi-hat",
        "Wood block",
        "Tambourine",
        "Rattle (instrument)",
        "Maraca",
        "Gong",
        "Tubular bells",
        "Mallet percussion",
        "Marimba, xylophone",
        "Glockenspiel",
        "Vibraphone",
        "Steelpan",
        "Orchestra",],
    "Brass": [
        "Brass instrument",
        "French horn",
        "Trumpet",
        "Trombone",
        "Bowed string instrument",
        "String section",
        "Violin, fiddle",
        "Pizzicato",
        "Cello",
        "Double bass",],
    "Wind": [
        "Wind instrument, woodwind instrument",
        "Flute",
        "Saxophone",
        "Clarinet",
        "Harp",
        "Bell",
        "Church bell",
        "Jingle bell",
        "Bicycle bell",
        "Tuning fork",
        "Chime",
        "Wind chime",
        "Change ringing (campanology)",
        "Harmonica",
        "Accordion",
        "Bagpipes",
        "Didgeridoo",
        "Shofar",
        "Theremin",
        "Singing bowl",
        "Scratching (performance technique)",
    ]
}

export const genreClassification = {
    "Pop": ["Pop music"],
    "Hip hop": ["Hip hop music", "Beatboxing", "Rhythm and blues"],
    "Rock": ["Rock music", "Progressive rock", "Rock and roll", "Psychedelic rock", "Grunge", "Funk", "Blues"],
    "Punk": ["Punk rock", "Ska"],
    "Metal": ["Heavy metal"],
    "Soul": ["Soul music"],
    "Reggae": ["Reggae"],
    "Country": ["Country",],
    "Jazz": ["Jazz", "Swing music"],
    "Folk": ["Bluegrass", "Folk music"],
    "Disco": ["Disco"],
    "Classical": ["Classical music", "Opera"],
    "Techno": ["Electronic music", "House music", "Techno", "Dubstep", "Drum and bass", "Electronica", "Electronic dance music", "Trance music"],
    "Ambient": ["Ambient music", "New-age music"],
}

export const vocalClassifications = {
    "Vocal": ["Vocal music"],
}

export const regionalClassifications = {
    "Middle Eastern": ["Middle Eastern music"],
    "African": ["Music of Africa", "Afrobeat"],
    "Asian": ["Music of Asia"],
    "Indian": ["Music of Bollywood", "Carnatic music",],
    "Latin/Spanish": ["Flamenco", "Salsa music", "Music of Latin America"]
}

export const typeClasifications = {
    "Traditional": "Traditional music",
    "Indie": "Independent music",
    "Christmas": ["Jingle (music)", "Christmas music", "Christian music", "Gospel music"],
    "Dance": ["Dance music"],
    "Game": ["Video game music", "Theme music", "Background music"],
    "Wedding": ["Wedding music"],
    "Children": ["Music for children", "Lullaby"],
    "A capella": ["A capella"],
}

export const emotionClassifications = {
    "Happy": ["Happy music"],
    "Sad": ["Sad music"],
    "Tender": ["Tender music"],
    "Exciting": ["Exciting music"],
    "Angry": ["Angry music"],
    "Scary": ["Scary music"],
}

